import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { MarketProvider } from "@/i18n/MarketContext";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <MarketProvider>
        <LanguageProvider>
          <App />
        </LanguageProvider>
      </MarketProvider>
    </QueryClientProvider>
  </React.StrictMode>,
);
